import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "./../../api/apiCaller";

export const SEND_SMS = "SEND_SMS";
export const SEND_SMS_SUCCESS = "SEND_SMS_SUCCESS";
export const SEND_SMS_ERROR = "SEND_SMS_ERROR";

export const GET_LIST_SMS = "GET_LIST_SMS";
export const GET_LIST_SMS_SUCCESS = "GET_LIST_SMS_SUCCESS";
export const GET_LIST_SMS_ERROR = "GET_LIST_SMS_ERROR";

export const COUNT_LIST_SMS = "COUNT_LIST_SMS";
export const COUNT_LIST_SMS_SUCCESS = "COUNT_LIST_SMS_SUCCESS";
export const COUNT_LIST_SMS_ERROR = "COUNT_LIST_SMS_ERROR";

/**
 * Reducer
 */

const initialState = {};

export const smsReducer = (state = initialState, action) => {
  switch (action.type) {
    //send sms
    case SEND_SMS:
      return {
        ...state,
      };
    case SEND_SMS_SUCCESS:
      return {
        ...state,
        sms: action.payload,
      };
    case SEND_SMS_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //get list
    case GET_LIST_SMS:
      return {
        ...state,
      };
    case GET_LIST_SMS_SUCCESS:
      return {
        ...state,
        listSms: action.payload,
      };
    case GET_LIST_SMS_ERROR:
      return {
        ...state,
        error: action.error,
      };

    //count
    case COUNT_LIST_SMS:
      return {
        ...state,
      };
    case COUNT_LIST_SMS_SUCCESS:
      return {
        ...state,
        count: action.payload,
      };
    case COUNT_LIST_SMS_ERROR:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
};

/**
 * Action
 */

// export const sendSMS = (sms) => ({
//     type: SEND_SMS,
//     data: [
//         ...sms
//     ]
// });

export const sendSMS = (from, to, content) => ({
  type: SEND_SMS,
  data: { from, to, content },
});

export const getListSMS = (order, limit, skip, where) => ({
  type: GET_LIST_SMS,
  data: {
    order,
    limit,
    skip,
    where,
  },
});

export const countListSms = (where) => ({
  type: COUNT_LIST_SMS,
  data: {
    where,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      sendSMS,
      getListSMS,
      countListSms,
    },
    dispatch
  );
};

/**
 * Apis
 */

// const sendSMSApi = (sms) => {
//     return apiCaller.post("/messaging/sms", [...sms]);
// };
const sendSMSApi = (from, to, content) => {
  return apiCaller.post("messaging/sms", { from, to, content });
};

const getListSMSApi = (order, limit, skip, where) => {
  return apiCaller.getLogs("/messaging/sms", { order, limit, skip, ...where });
};

const countListSmsApi = (where) => {
  return apiCaller.getLogs("/messaging/sms/count", { where });
};

/**
 * sagas
 */

// export const sendSMSFlow = function* () {
//     while (true) {
//         const action = yield take(SEND_SMS);
//         try {
//             const res = yield call(sendSMSApi, action.data)
//             yield put({ type: SEND_SMS_SUCCESS, payload: { ...res.data } })
//         } catch (error) {
//             yield put({ type: SEND_SMS_ERROR, error })
//         }
//     }
// };

export const sendSMSFlow = function* () {
  while (true) {
    const action = yield take(SEND_SMS);
    try {
      const res = yield call(
        sendSMSApi,
        action.data.from,
        action.data.to,
        action.data.content
      );
      yield put({ type: SEND_SMS_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: SEND_SMS_ERROR, error });
    }
  }
};

export const getListSMSFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_SMS);
    try {
      const res = yield call(
        getListSMSApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where
      );
      yield put({
        type: GET_LIST_SMS_SUCCESS,
        payload: { ...res.data },
        data: action.data,
      });
    } catch (error) {
      yield put({ type: GET_LIST_SMS_ERROR, error });
    }
  }
};

export const countListSmsFlow = function* () {
  while (true) {
    const action = yield take(COUNT_LIST_SMS);
    try {
      const res = yield call(countListSmsApi, action.data.where);
      yield put({
        type: COUNT_LIST_SMS_SUCCESS,
        payload: {
          ...res.data,
        },
      });
    } catch (error) {
      yield put({ type: COUNT_LIST_SMS_ERROR, error });
    }
  }
};
